import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { SimuladorService } from '../../../services/operaciones/simulador/simulador.service';
import * as moment from 'moment';
import { TipoCambioService } from 'app/services/configuracion/tipo-cambio.service';
import { environment } from 'environments/environment';
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;
@Component({
  selector: 'app-listado-simulador',
  templateUrl: './listado-simulador.component.html',
  styleUrls: ['./listado-simulador.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoSimuladorComponent implements OnInit {

  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  Label_id_soles=environment.ID_GUIA_SOLES;

  flagSimuladorDetalle: boolean = false;
  idSimulador: number = 0;
  urlResumen: any;
  url: any;
  simulador: any = [];
  ruc = new FormControl();
  rucAdq = new FormControl();
  idProv = "";
  idAdq = "";

  // Entradas de Busqueda
  RUC_PROV: string;
  RUC_ADQ: string;
  Canal: any = [];
  FFinal: any = moment();
  FInicial: any = moment().date(1);

  filteredProveeedor: Observable<any[]>;
  proveedoresArr;

  filteredAdquirentes: Observable<any[]>;
  adquirentessArr;
  user:any;
  user_id:any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  docNegociables: any = [];
  loading: boolean;
  displayedColumns: string[] =
    ['checked', 'idSimulador', 'Fecha', 'NombreProveedor', 'NombreAdquirente', 'Moneda', 'Importe',
      'VNPP', 'Adelanto', 'Factoring', 'Desembolso', 'Canal'];
  dataSource: any;
  constructor(private simuladorService: SimuladorService, private datePipe: DatePipe, private tipoCambioService: TipoCambioService) {
    this.user = JSON.parse(sessionStorage.getItem('UserActive')); }

  ngOnInit() {
    this.ListadoSimuladorFiltros();
    this.ObtenerProveedoresCombo();
    this.ObtenerAdquirentesCombo();
  }

  canal(event) {
    this.Canal = event;
  }

  MetCerrarSimuladorDetalle() {
    this.flagSimuladorDetalle = false;
  }

  ListadoSimuladorFiltros() {    
    /*this.user_id=Buffer.from(this.user.id_user.toString()).toString('base64');*/
    this.user_id=this.user.id_user;
    if (this.ruc.value == '') this.idProv = '';
    if (this.rucAdq.value == '') this.idAdq = '';
    this.loading = true;
    this.tipoCambioService.obtenerTipoCambio().subscribe(
      res => {
        let tipocambio: any;
        tipocambio = res;
        if (tipocambio.length > 0) {
          this.simuladorService.FiltroListadoSimulador(this.datePipe.transform(this.FInicial, 'yyyy-MM-dd'),
            this.datePipe.transform(this.FFinal, 'yyyy-MM-dd'),
            this.idProv, this.idAdq, this.Canal,this.user_id)
            .subscribe(
              res1 => {
                this.simulador = res1;
                console.log('simuladores', this.simulador)
                this.dataSource = new MatTableDataSource(this.simulador);
                this.dataSource.sort = this.sort;
                this.dataSource.paginator = this.paginator;
                this.loading = false;
              }, err => {
                Swal.fire({
                  title: "¡Algo salió mal!",
                  text: err.error['error'],
                  type: "warning",
                  allowOutsideClick: true,
                  heightAuto: false
                });
                this.loading = false;
              }
            )
        } else {                    
          Swal.fire({
            title: "Registrar tipo de cambio",
            text: "Coordinar con el área de contabilidad",
            allowOutsideClick: true,
            heightAuto: false
          });
          this.loading = false;
        }
      }
    )

  }

  obtenerRucRazSocialAdq(termino: string = '') {
    if (termino != null && termino != '') {
      let termino1 = termino.toLowerCase();
      for (let p of this.adquirentessArr) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {
          this.idAdq = p.Num_Doc_Identificacion;
        }
      }
    }
  }


  obtenerRucRazSocialProv(termino: string = '') {

    if (termino != null && termino != '') {

      let termino1 = termino.toLowerCase();

      for (let p of this.proveedoresArr) {

        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {
          this.idProv = p.Num_Doc_Identificacion;
        }
      }
    }
  }


  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveeedor = this.ruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      );
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true||
      state.Num_Doc_Identificacion.includes(filterValue) === true
    );
  }

  ObtenerAdquirentesCombo() {
    this.adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.rucAdq.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterAdq(state) : this.adquirentessArr.slice()
        )
      );
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentessArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  obtenerRucProv(termino: string) {
    this.idProv = termino;
  }

  obtenerRucAdq(termino: string) {
    this.idAdq = termino;
  }

  enviarIdSimulador(idSimulador: any) {
    this.idSimulador = idSimulador;
    this.flagSimuladorDetalle = true;
  }

  obtenerpdfResumen($file: any) {
    window.open($file, "_blank");
  }

  obtenerpdf($file: any) {
    window.open($file, "_blank");
  }
}
